const styleSheet = () => ({
  switchToMap: {
    position: "fixed",
    backgroundColor: "#fff",
    width: "100%",
    maxWidth: "433px",
    boxSizing: "border-box",
    padding: "18px 28px",
    left: "50%",
    transform: "translateX(-50%)",
    boxShadow: "0 4px 8px 0 rgb(0 0 0 / 20%)",
    borderRadius: "8px",
    top: "32px",
    fontFamily: "CircularStd",
    fontWeight: 500,
    zIndex: 10000,
    "& h2": {
      padding: 0,
      margin: 0,
      fontSize: "18px",
      marginBottom: "21px",
    },
    "& p": {
      color: "#6373A4",
      fontSize: "14px",
      padding: 0,
      marginBottom: 0,
    },
    "@media (max-width: 1200px)": {
      top: "inherit",
      width: "92%",
      bottom: "70px",
    },
  },
  closePrompt: {
    position: "absolute",
    right: "10px",
    top: "10px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
  },
});

export default styleSheet;
